module.exports = __webpack_public_path__ + "static/media/clouds_sun.413162dd.jpg";